import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Spinner, Table } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useEffectOnce } from 'react-use';

import { CouponRow } from './CouponRow';

import { Button } from '../../components/Button';
import { SideBar } from '../../components/SideBar';
import { Title, Text } from '../../components/Typography';

import { couponsFetchRequest } from '../../actions/coupons';
import { getCoupons } from '../../selectors/coupons';
import { getUser } from '../../selectors/user';
import { api } from '../../utils/api';

export const Coupons = () => {
  const dispatch = useDispatch();
  const coupons = useSelector(getCoupons);
  const user = useSelector(getUser);
  const [couponRequested, setCouponRequested] = useState(false);

  useEffectOnce(() => {
    dispatch(couponsFetchRequest());
  });

  useEffect(() => {
    const claimFreeCoupon = async () => {
      try {
        await api.post(`/user/${user.data!.id}/coupons/create/50/1004535`, {
          Authorization: `Bearer ${user.data!.token}`,
        });
      } finally {
        setCouponRequested(true);
      }

      dispatch(couponsFetchRequest());
    };

    if (
      user.data?.privacyChecked === '3' &&
      user.data?.marketingChecked &&
      !coupons.fetching &&
      !coupons.data.some((coupon) => coupon.coupon_codice === 'WELCOME10') &&
      !coupons.data.some((coupon) => coupon.coupon_codice === 'WELCOME15') &&
      !couponRequested
    ) {
      claimFreeCoupon();
    }
  }, [coupons.data, user.data, couponRequested, coupons.fetching, dispatch]);

  if (coupons.fetching) {
    return (
      <Spinner animation={'border'} role={'status'}>
        <span className={'sr-only'}>Loading...</span>
      </Spinner>
    );
  }

  return (
    <SideBar>
      <Title as={'h3'}>Coupon</Title>

      {!user.isEligibleForCoupon ? (
        <div>
          <Text>
            Per ottenere un buono sconto devi completare il tuo profilo.
          </Text>

          <Button as={Link} to={'/'}>
            Vai al profilo
          </Button>
        </div>
      ) : (
        <Text>Per il momento non sono disponibili altri coupon</Text>
      )}

      <Table responsive>
        <thead>
          <tr>
            <th>#</th>
            <th>Coupon</th>
            <th />
          </tr>
        </thead>

        <tbody>
          {coupons.data.map((coupon) => (
            <CouponRow coupon={coupon} />
          ))}
        </tbody>
      </Table>
    </SideBar>
  );
};
